import { CloseOutlined } from '@mui/icons-material'
import { Button, Grid, IconButton, Typography } from '@mui/material'
import React, { memo, useEffect, useState } from 'react'
import CustomTable from '../../customTable'
import EditRoundedIcon from "@mui/icons-material/EditRounded";
import _ from 'lodash';
import moment from 'moment';
import VisibilityIcon from '@mui/icons-material/Visibility';
const MonthReports = ({setOpen , monthData,getDateData , setActiveStep}) => {
    const pageOption = [10, 25, 50, 100];
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(pageOption[0]);
    const [pageCount, setPageCount] = useState(0);
    const onEditDate = (e) => {
        console.log(e.row)
        getDateData(e.row.date)
        setActiveStep("1")
    }
    const columns = [
        {
            field : 'sno',
            headerName : 'S.no',
            minWidth : 70,
            maxWidth : 100,
            headerAlign : 'center',
            align : 'center',
            sortable: false
          },
          {
            field: "date",
            headerName: "Date",
            flex: 1,
            headerAlign: "center",
            align: "center",
            sortable: false,
          },
          {
            field: "amount",
            headerName: "Amount",
            flex: 1,
            headerAlign: "center",
            align: "center",
            sortable: false,
          },
          {
            field: "view",
            headerName: "View",
            flex: 1,
            headerAlign: "center",
            align: "center",
            disableExport: true ,
            sortable: false,
            renderCell : (params) => {
                return(
                    <IconButton
                    size="small"
                    onClick={() => onEditDate (params)}
                    >
                        <VisibilityIcon />
                    </IconButton>
                )
            }
          },
    ]
    const rows = _.map(monthData.details,(value,idx) =>({
        id: idx,
        sno: idx+1,
        date:moment(value.date).format('YYYY-MM-DD'),
        amount:value.amount
    }))
    const props = {
        columns : columns,
        rows : rows,
        page: page,
        setPage: setPage,
        rowsPerPage: rowsPerPage,
        setRowsPerPage: setRowsPerPage,
        pageCount: pageCount,
        pageOption: pageOption,
      }
      useEffect(()=>{

        if(monthData.details){
            const arr = monthData.details
            setPageCount(arr.length)
        }
      },[monthData])
  return (
    <Grid>
        <Grid sx={{display:"flex" , justifyContent:"space-between",padding:1,alignItems:"center"}}>
            <Button variant='contained' onClick={() => setOpen(false)}>Back</Button>
            <Typography variant='h6'>Monthly reports</Typography>
            <IconButton onClick={() => {setOpen(false);setActiveStep("0")}}>
                <CloseOutlined />
            </IconButton>
        </Grid>
        <Grid>
            <CustomTable props={props}/>
        </Grid>
    </Grid>
  )
}

export default memo(MonthReports)